import axios from 'axios'

// ACTION TYPES
const name = 'data'

export const actionTypes = {
  FETCH_MODEL_DATA_BY_HOLDING_TICKER: `${name}:FETCH_MODEL_DATA_BY_HOLDING_TICKER`,

  FETCH_FUND_DATA: `${name}:fetch_fund_data`,
  //SET_MODEL_FAMILY: `${name}:set_model_family`,
  SET_SELECTED_APPROACH: `${name}:set_selected_approach`,
  UPDATE_FAMILIES: `${name}:update_families`,
  UPDATE_RISK_PROFILES: `${name}:update_risk_profiles`,
  SET_SELECTED_TICKERS: `${name}:set_selected_tickers`,
  SET_SELECTED_RISK_PROFILES: `${name}:set_selected_risk_profiles`,
  SET_MODEL_RISK_TOLERANCE: `${name}:set_model_risk_tolerance`,
  FILTER_DATA: `${name}:filter_data`,
  SET_TICKERS: `${name}:set_tickers`,
  USER_CUSTOM_MODEL_DATA: `${name}:user_custom_model_data`,
  USER_CHANGED_DATA: `${name}:user_changed_data`,
  SUBMITTING_TO_PS: `${name}:submitting_to_ps`,
  SET_SAVED_APPROACH: `${name}:set_saved_approach`,
  SET_SAVED_SLEEVE: `${name}:set_saved_sleve`,
  SET_SELECTED_MODEL_TICKERS: `${name}:set_selected_model_tickers`,
  SET_SELECTED_MODEL_NAMES: `${name}:set_selected_model_names`,
  SAVED_TO_DB: `${name}:saved_to_db`,
  RESET_STATE: `${name}:reset_state`,
  SAVING_IN_PROGRESS: `${name}:saving_in_progress`,
  SET_PROGRESS_BAR_VALUE: `${name}:set_progress_bar_value`,
  SAVE_MODEL: `${name}:save_model`,
  UPDATE_ALL_STATUSES: `${name}:update_all_statuses`,
  START_FETCHING_DATA: `${name}:start_fetching_data`,
  UPDATE_ALLOCATIONS_DECIDED: `${name}:update_allocations_decided`,
  REVIEW_COMPLETED: `${name}:review_completed`
}

export const resetState = stateKey => {
  console.log(`resetState action dispatched with stateKey: ${stateKey}`)
  return {
    type: actionTypes.RESET_STATE,
    value: stateKey
  }
}

export const startFetchingData = () => ({
  type: actionTypes.START_FETCHING_DATA
})

export const reviewCompleted = () => ({
  type: actionTypes.REVIEW_COMPLETED
});



export const fetchModelsData = params => async (dispatch, getState) => {
  //console.log('getState', getState())
  const {
    params: { clientEmail, token }
  } = getState().params
  try {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/modelhighlights/models/?clientEmail=${clientEmail}&type=WTCOD`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`
      }
    }
    console.log('request', request)

    // Add a delay of 3 minutes to test spinner
    setTimeout(async () => {
      const response = await axios(request)
      console.log('response', response)

      dispatch({
        type: actionTypes.FETCH_FUND_DATA,
        value: {
          data: response.data
        }
      })
    }, 100)
  } catch (error) {
    console.error('Error fetching fund data:', error)
  }
}

//without delay - after testing
// export const fetchModelsData = params => async (dispatch, getState) => {
//   const {
//     params: { clientEmail, token }
//   } = getState().params
//   try {
//     const request = {
//       method: 'GET',
//       url: `${process.env.REACT_APP_API_URL}/modelhighlights/models/?clientEmail=${clientEmail}&type=WTCOD`,
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Token ${token}`
//       }
//     }
//     console.log('request', request)

//     const response = await axios(request)
//     console.log('response', response)

//     dispatch({
//       type: actionTypes.FETCH_FUND_DATA,
//       value: {
//         data: response.data
//       }
//     })
//   } catch (error) {
//     console.error('Error fetching fund data:', error)
//   }
// }

// export function fetchModelDataByAssetClass({ tickers, clientEmail }) {
//   return (dispatch, getState) => {
//     const request = {
//       method: 'GET',
//       url: `${process.env.REACT_APP_API_URL}/modelhighlights/models/?consolidateByHoldingAssetClasses=1`,
//       params: {
//         tickers: tickers,
//         clientEmail: clientEmail
//       }
//     }
//     return axios(request)
//       .then(response => {
//         dispatch({
//           type: actionTypes.FETCH_MODEL_DATA_BY_HOLDING_TICKER,
//           value: response.data
//         })
//       })
//       .catch(error => {
//         console.error(error)
//         throw error
//       })
//   }
// }

//Step 1 - first Screen
export function setSelectedApproach(paramVal) {

  return (dispatch, getState) => {
    const state = getState()
    // console.log('STATE', state.data.families)
    if (state.data.families && state.data.families.length > 0) {
      const selectedFamily = state.data.families.find(
        family => family.familyName === paramVal.value
      )

      dispatch({ type: actionTypes.SET_SELECTED_APPROACH, value: paramVal })

    } else {
      console.log('family/approach is empty or undefined')
    }
  }
}

export function setSelectedTickers(tickers) {
  //console.log('ACTIONS - SELECTED TICKERS', tickers)
  return dispatch => {
    dispatch({ type: actionTypes.SET_SELECTED_TICKERS, value: tickers })
  }
}

export function userCustomModelData({ userCustomModelData, title }) {
  return dispatch => {
    dispatch({
      type: actionTypes.USER_CUSTOM_MODEL_DATA,
      value: { userCustomModelData, title }
    })
  }
}

export function userChangedData({ userChangedData }) {
  return dispatch => {
    dispatch({ type: actionTypes.USER_CHANGED_DATA, value: userChangedData })
  }
}

export function saveNewStrategy() {
  return async (dispatch, getState) => {
    const {
      data: { userCustomModelData },
      params
    } = getState()

    if (params.token !== 'undefined' || !params.token) {
      dispatch({ type: actionTypes.SUBMITTING_TO_PS, value: true })

      const requests = Object.keys(userCustomModelData).map(key => {
        const body = userCustomModelData[key]

        return axios({
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/personalstrategies/`,
          data: body,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${params.token}`
          }
        })
      })

      try {
        await Promise.all(requests)
      } catch (error) {
        console.error(error)
      } finally {
        dispatch({ type: actionTypes.SUBMITTING_TO_PS, value: false })
      }
    }
  }
}
const postModelToDB = async (
  payload,
  token,
  dispatch,
  model,
  index,
  chosenModelsLength,
  allStatuses,
  customModelName
) => {
  // console.log('Parameters:', {
  //   payload,
  //   token,
  //   model,
  //   index,
  //   chosenModelsLength,
  //   allStatuses,
  //   customModelName
  // })

  const TIMEOUT = 3 * 60 * 1000; // 5 minutes timeout


  const request = {
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/modelhighlights/modelcustomswaps/?allowBackendPost=1`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`
    },
    data: payload,
    timeout: TIMEOUT
  }
  //Wait for 2 minutes
  //await new Promise(resolve => setTimeout(resolve, 1 * 60 * 1000));

  try {
    const response = await axios(request)
    const status = response.status === 200 || response.status === 201 ? 200 : -1

    allStatuses.push({ status: status, name: model.customModelName })
    //  console.log('allStatuses', allStatuses)

    return response.status
  } catch (error) {
    console.error(`Error posting custom model ${model.chosenModelTicker}`, error)
    allStatuses.push({ status: -1, name: model.customModelName })
    //console.log('allStatuses', allStatuses)
    return -1
  }
}
export const savingModelsToDB =
  (selectedModels, selectedNewModelNames, sleeveSaved) => async (dispatch, getState) => {
    // const { params, data } = getState()
    const chosenModels = selectedModels.map((model, index) => ({
      customModelName: selectedNewModelNames[index],
      chosenModelTicker: model
    }))

    const tickerSwaps = sleeveSaved.swaps.map(swap => ({
      newTicker: swap.newTicker,
      originalTicker: swap.originalTicker
    }))

    const {
      params: { clientEmail, token }
    } = getState().params

    const allowRebalance = true
    const allStatuses = []

    // Create an array of promises
    const promises = chosenModels.map((model, index) => {
      const payload = {
        clientEmail,
        chosenModels: [model],
        tickerSwaps,
        allowRebalance
      }

      return postModelToDB(
        payload,
        token,
        dispatch,
        model,
        index,
        chosenModels.length,
        allStatuses,
        model.customModelName
      )
        .then(status => {
          // Update the status in the allStatuses array
          const updatedAllStatuses = allStatuses.map(statusObj =>
            statusObj.name === model.name ? { ...statusObj, status } : statusObj
          )

          //console.log('Dispatching UPDATE_ALL_STATUSES:', updatedAllStatuses)
          dispatch({ type: actionTypes.UPDATE_ALL_STATUSES, value: updatedAllStatuses })
          //console.log('Updated Statuses:', updatedAllStatuses)
        })
        .catch(error => {
          console.error('Error in postModelToDB:', error)
        })
    })
    // Use Promise.all to send all requests in parallel
    try {
      await Promise.all(promises)
    } catch (error) {
      console.error('Error posting models:', error)
    }

    dispatch({
      type: actionTypes.SAVED_TO_DB,
      value: true
    })
    dispatch({
      type: actionTypes.SAVING_IN_PROGRESS,
      value: false
    })
    dispatch(saveToGA('Create'));
  }


//step Three
export function setSelectedRiskProfiles(selectedButtons) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SELECTED_RISK_PROFILES, value: selectedButtons })

  }
}

export function saveApproach(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SAVED_APPROACH, value: value })
  }
}

export function saveSleeve(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SAVED_SLEEVE, value: value })
  }
}


export function setProgressBarValue(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_PROGRESS_BAR_VALUE, value: value })
  }
}

export function savingInProgress(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SAVING_IN_PROGRESS, value: value })
  }
}

export const saveModel = (model, index, totalCount) => ({
  type: actionTypes.SAVE_MODEL,
  value: {
    name: model.customModelName,
    index: index + 1,
    length: totalCount
  }
})

export const updateAllocationsDecided = (value) => ({
  type: actionTypes.UPDATE_ALLOCATIONS_DECIDED,
  value: value
});
// end db
export const saveUpdatedNamesAndTickers = (newNames, selectedTickers) => {
  // console.log('HERE', newNames, selectedTickers)
  return dispatch => {
    dispatch({ type: actionTypes.SET_SELECTED_MODEL_TICKERS, value: selectedTickers })
    dispatch({ type: actionTypes.SET_SELECTED_MODEL_NAMES, value: newNames })
  }
}



// Save the run of loaded funds to GA
export function saveToGA(eventAction) {
  return (dispatch, getState) => {
    const e = {
      'eventName': 'Custom Models',
      'eventAction': eventAction,
      // 'eventLabel': `${getState().performance.fund}_${getState().performance.bmk}`,
      eventLabel: 'Create',
      'type': 'CustomTagEvent'
    };

    if (window.digitalData) {
      if (e.Label !== '') {
        window.digitalData.newEvent(e);
        console.log('digitalData: ', e);
      }
    } else {
      console.log('no digitalData: ', e);
    }
  }
}